import { useState, useEffect } from "react";
import { getProductPage, getProducts } from "../../services/api";
import { ProductImage, ProductModal } from "../../components/site/ProductUi";
import { DetailedProductModal } from "../../components/site/DetailedProductModal";
import { CATEGORY_COLORS } from "./data/categoryColors";
import "../../components/site/ProductImage.css";
import { SharedHeader, SharedFooter, PageHero, Breadcrumb, NAVY, ORANGE, WHITE } from "../../components/site/SharedLayout";
import PageLoader from "../../components/site/PageLoader";
import SEO from "../../components/SEO";


export function SupportiveCarePage() {
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [hoveredId, setHoveredId] = useState(null);
const [pageData, setPageData] = useState(null);
const [products, setProducts] = useState([]);

const [activeFilter, setActiveFilter] = useState("All");
const [searchQuery, setSearchQuery] = useState("");
const [useDetailedView, setUseDetailedView] = useState(false);

useEffect(() => {
  async function loadPage() {
    try {
      const page = await getProductPage("supportive-care");
      const productData = await getProducts("supportive-care");

      setPageData(page);
      setProducts(productData.products || []);
    } catch (err) {
      // silently fail
    }
  }

  loadPage();
}, []);
if (!pageData) {
  return <PageLoader />;
}
  const seo = pageData?.seo || {};


const allProducts = products;

  const categories = [
  "All",
  ...Array.from(new Set(allProducts.map(p => p.category))),
];

  const filtered = allProducts.filter(p => {
    const matchCat =
      activeFilter === "All" || p.category === activeFilter;

    const matchSearch =
      searchQuery === "" ||
      p.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
      p.generic_name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      p.indications.toLowerCase().includes(searchQuery.toLowerCase());

    return matchCat && matchSearch;
  });
  return (
    <>
  <SEO
    title={seo.title}
    description={seo.description}
    canonical={seo.canonical}
    robots={seo.robots}
    keywords={seo.keywords}
    ogTitle={seo.ogTitle}
    ogDescription={seo.ogDescription}
    ogImage={seo.ogImage}
    twitterTitle={seo.twitterTitle}
    twitterDescription={seo.twitterDescription}
    twitterImage={seo.twitterImage}
   author="GLS Pharma"
  publisher="GLS Pharma"
  />
    <div style={{ fontFamily: "'Inter', 'Segoe UI', Arial, sans-serif", margin: 0, padding: 0, color: "#222", background: "#f8fafc" }}>
      <SharedHeader />
      <Breadcrumb items={[{ label: "Home", path: "/" }, { label: "Products", path: "/products/supportive-care" }, { label: "Supportive Care" }]} />
      <PageHero
  label={pageData?.hero?.title}
  title={pageData?.hero?.subtitle}
  subtitle={pageData?.hero?.description}
  bgImage={pageData?.hero?.image?.url}
/>
      {/* ── FILTER & SEARCH BAR ── */}
      <div className="product-filter-bar" style={{
        background: WHITE,
        borderBottom: "1px solid #e5ecf9",
        padding: "20px 80px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 24,
        position: "sticky",
        top: 80,
        zIndex: 100,
        boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
      }}>
        {/* Filters */}
        <div style={{ display: "flex", gap: 8, flexWrap: "wrap", flex: 1 }}>
          {categories.map(cat => {
            const catStyle = CATEGORY_COLORS[cat];
            const isActive = activeFilter === cat;
            return (
              <button
                key={cat}
                onClick={() => setActiveFilter(cat)}
                style={{
                  padding: "7px 16px",
                  borderRadius: 20,
                  border: isActive
                    ? `2px solid ${cat === "All" ? NAVY : (catStyle?.border || NAVY)}`
                    : "2px solid #e5ecf9",
                  background: isActive
                    ? (cat === "All" ? NAVY : (catStyle?.bg || "#f8faff"))
                    : WHITE,
                  color: isActive
                    ? (cat === "All" ? WHITE : (catStyle?.text || NAVY))
                    : "#556",
                  fontSize: 12,
                  fontWeight: 600,
                  cursor: "pointer",
                  transition: "all 0.15s",
                  whiteSpace: "nowrap",
                }}
              >
                {cat}
              </button>
            );
          })}
        </div>

        {/* Search */}
        <div style={{ position: "relative", flexShrink: 0 }}>
          <input
            value={searchQuery}
            onChange={e => setSearchQuery(e.target.value)}
            placeholder="Search products..."
            style={{
              padding: "9px 16px 9px 36px",
              border: "1px solid #dde4ef",
              borderRadius: 10,
              fontSize: 13,
              outline: "none",
              width: 220,
              background: "#f8fafc",
            }}
          />
          <svg
            style={{ position: "absolute", left: 11, top: "50%", transform: "translateY(-50%)" }}
            width="15" height="15" viewBox="0 0 24 24" fill="none">
            <circle cx="11" cy="11" r="7" stroke="#94a3b8" strokeWidth="2" />
            <path d="m21 21-4-4" stroke="#94a3b8" strokeWidth="2" strokeLinecap="round" />
          </svg>
        </div>

        {/* View Mode Toggle */}
        <button
          onClick={() => setUseDetailedView(!useDetailedView)}
          style={{
            padding: "8px 16px",
            borderRadius: 8,
            border: "1px solid #dde4ef",
            background: useDetailedView ? NAVY : WHITE,
            color: useDetailedView ? WHITE : NAVY,
            fontSize: 12,
            fontWeight: 600,
            cursor: "pointer",
            marginRight: 16
          }}
        >
          {useDetailedView ? "📋 Detailed" : "📄 Simple"}
        </button>

        {/* Count */}
        <div style={{ color: "#667", fontSize: 13, flexShrink: 0 }}>
          {filtered.length} product{filtered.length !== 1 ? "s" : ""}
        </div>
      </div>
      {/* ── PRODUCT GRID ── */}
      <section style={{ padding: "48px 80px 80px" }}>
        {filtered.length === 0 ? (
          <div style={{ textAlign: "center", padding: "80px 0", color: "#94a3b8" }}>
            <div style={{ fontSize: 48, marginBottom: 16 }}>🔍</div>
            <div style={{ fontSize: 20, fontWeight: 600 }}>No products found</div>
            <div style={{ fontSize: 18, marginTop: 8 }}>Try adjusting your search or filter</div>
          </div>
        ) : (
          <div style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))",
            gap: 20,
            padding: "8px 4px",
          }}>
            {filtered.map(product => {
              const catStyle = CATEGORY_COLORS[product.category] || {};
              return (
                <div
                  key={product.id}
                  onClick={() => setSelectedProduct(product)}
                  className="product-card-enhanced"
                  style={{
                    background: WHITE,
                    borderRadius: 18,
                    border: `1px solid ${hoveredId === product.id ? NAVY : "#e8eef6"}`,
                    padding: 0,
                    cursor: "pointer",
                    transition: "transform 0.25s ease, box-shadow 0.25s ease, border-color 0.25s ease",
                    overflow: "hidden",
                    boxShadow: hoveredId === product.id
                      ? "0 20px 48px rgba(26, 60, 110, 0.18)"
                      : "0 2px 8px rgba(26, 60, 110, 0.06)",
                    transform: hoveredId === product.id ? "scale(1.12)" : "scale(1)",
                    position: "relative",
                    zIndex: hoveredId === product.id ? 2 : 1,
                  }}
                  onMouseEnter={() => setHoveredId(product.id)}
                  onMouseLeave={() => setHoveredId(null)}
                >
                  {/* Card Image */}
                  <div style={{
                    borderRadius: "18px 18px 0 0",
                    overflow: "hidden",
                    borderBottom: "1px solid #e5ecf9",
                  }}>
                    <ProductImage product={product} />
                  </div>

                  {/* Card Body */}
                  <div style={{ padding: "16px 18px 20px" }}>
                    {/* Category pill */}
                    <div style={{
                      display: "inline-flex",
                      alignItems: "center",
                      gap: 5,
                      background: catStyle.bg || "#f8faff",
                      border: `1px solid ${catStyle.border || "#e5ecf9"}`,
                      color: catStyle.text || NAVY,
                      fontSize: 10,
                      fontWeight: 700,
                      padding: "3px 10px",
                      borderRadius: 20,
                      marginBottom: 10,
                      textTransform: "uppercase",
                      letterSpacing: 0.5,
                    }}>
                      {product.category}
                    </div>

                    {/* Name */}
                    <h3 style={{
                      fontSize: 20,
                      fontWeight: 700,
                      color: NAVY,
                      margin: "0 0 4px",
                      lineHeight: "28px",
                      letterSpacing: -0.2,
                      textAlign: "left",
                    }}>
                      {product.title}
                    </h3>

                    {/* View details hint */}
                    <div style={{
                      marginTop: 8,
                      fontSize: 12,
                      color: ORANGE,
                      fontWeight: 600,
                      display: "flex",
                      alignItems: "center",
                      gap: 4,
                    }}>
                      {useDetailedView ? "📋 Detailed info" : "View details"}
                      <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
                        <path d="M5 12h14M12 5l7 7-7 7" stroke={ORANGE} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </section>



      <section style={{ padding: "0 80px 80px" }}>
  <div
    style={{
      background: `linear-gradient(135deg, #0a1f4e, ${NAVY})`,
      borderRadius: 20,
      padding: "44px 60px",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    }}
  >
    <div>
      <div
        style={{
          color: ORANGE,
          fontWeight: 700,
          fontSize: 11,
          letterSpacing: 2,
          textTransform: "uppercase",
          marginBottom: 8,
        }}
      >
        {pageData?.catalogue_cta?.small_title}
      </div>

      <h3
        style={{
          color: WHITE,
          fontWeight: 800,
          fontSize: 36,
          margin: "0 0 8px",
        }}
      >
        {pageData?.catalogue_cta?.title}
      </h3>
    </div>

    <a
      href={pageData?.catalogue_cta?.button?.link}
      target="_blank"
      rel="noopener noreferrer"
      style={{ textDecoration: "none" }}
    >
      <button
        style={{
          background: WHITE,
          color: NAVY,
          border: "none",
          borderRadius: 10,
          padding: "13px 26px",
          fontWeight: 700,
          fontSize: 14,
          cursor: "pointer",
        }}
      >
        {pageData?.catalogue_cta?.button?.text}
      </button>
    </a>
  </div>
</section>
       {/* ── MODAL ── */}
{selectedProduct && (
  useDetailedView ? (
    <DetailedProductModal
      product={selectedProduct}
      onClose={() => setSelectedProduct(null)}
    />
  ) : (
    <ProductModal
      product={selectedProduct}
      onClose={() => setSelectedProduct(null)}
    />
  )
)}


      <SharedFooter />
    </div>
    </>
  );
}

export default SupportiveCarePage;
 